import { getI18nText } from 'pricing-pages-lib/utils/languageUtils';
import { useHistory } from 'react-router-dom';
import { BrandingAndLimitPriorityFeatures } from '../../../../v2/components/merch-card/feature-display/BrandingAndLimitPriorityFeatures';
import { UncategorizedPriorityFeatures } from '../../../../v2/components/merch-card/feature-display/UncategorizedPriorityFeatures';
import { MERCH_CARD } from '../../../../v2/constants/tracking/TrackingSources';
import { useIsFreePortal } from '../../../../v2/hooks/inventory/useProductInventory';
import { trackClickedLink } from '../../../../v2/utils/tracking/trackingEventUtils';
import SkeletonLoadWrapper from '../../../common/loading/SkeletonLoadWrapper';
import { StandardLowerTierMessage } from '../StandardLowerTierMessage';
import { useCategorizedPriorityFeatures } from '../useFeatures';
import { jsx as _jsx } from "react/jsx-runtime";
export const StandardFeaturesContainer = ({
  productLevel,
  productLine,
  productApiName,
  isCollapsible = false
}) => {
  const {
    isFreePortal,
    loading: isInventoryLoading
  } = useIsFreePortal();
  const {
    loading: isPriorityFeaturesLoading,
    brandingAndLimitFeatures,
    uncategorizedFeatures
  } = useCategorizedPriorityFeatures({
    productApiName
  });
  const loading = isInventoryLoading || isPriorityFeaturesLoading;
  const history = useHistory();
  const handleClick = () => {
    trackClickedLink({
      name: 'business-objective-link',
      value: getI18nText('merchCards.priorityFeatures.freeToolsWithLimits', {
        locale: 'en-us'
      }),
      type: 'internal',
      url: '/crm',
      trackingSource: MERCH_CARD
    });
    history.push('/crm');
  };
  return /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
    isLoading: loading,
    heights: [48, 48],
    widths: ['100%', '100%'],
    children: brandingAndLimitFeatures.length ? /*#__PURE__*/_jsx(BrandingAndLimitPriorityFeatures, {
      brandingAndLimitFeatures: brandingAndLimitFeatures,
      uncategorizedFeatures: uncategorizedFeatures,
      handleClickFreeToolsWithLimitsLink: handleClick,
      isCollapsible: isCollapsible,
      isFreePortal: isFreePortal
    }) : /*#__PURE__*/_jsx(UncategorizedPriorityFeatures, {
      uncategorizedFeatures: uncategorizedFeatures,
      lowerTierMessage: /*#__PURE__*/_jsx(StandardLowerTierMessage, {
        productLevel: productLevel,
        productLine: productLine,
        handleClick: handleClick
      }),
      isCollapsible: isCollapsible
    })
  });
};